import LayoutContainer from "../../components/Containers/LayoutContainer";
import "@fortawesome/fontawesome-free/css/all.min.css";
import React from "react";
import "./notification.scss";
import NotificationData from "./NotificationData";

const Notification: React.FunctionComponent = () => {
  return (
    <LayoutContainer title="notification">
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon  fa fa-bell"></i>
          Notification
        </h2>
      </div>
      <NotificationData />
    </LayoutContainer>
  );
};

export default Notification;
